import { fmtMoney } from "@/lib/format";
import { Card, CardContent } from "@/components/ui/card";

export const MonthlyTrendCard = ({ data }) => (
  <Card className="shadow-sm" data-testid="monthly-trend-card">
    <CardContent className="p-6">
      <h2 className="text-2xl font-serif font-semibold mb-6">Giving month by month</h2>
      {data?.monthly_revenue ? (
        data.monthly_revenue.every((m) => !m.amount) ? (
          <p className="text-muted-foreground text-sm" data-testid="monthly-trend-empty">No giving recorded yet. Import your first file to see the trend.</p>
        ) : (
        <div className="flex items-end gap-1.5 h-44" data-testid="monthly-trend-chart">
          {data.monthly_revenue.map((m) => {
            const max = Math.max(...data.monthly_revenue.map((x) => x.amount), 1);
            return (
              <div key={m.month} className="flex-1 h-full flex flex-col items-center justify-end gap-1.5" title={`${m.label} ${m.month.slice(0, 4)}: ${fmtMoney(m.amount)}`}>
                <div
                  className="w-full max-w-[30px] rounded-t-sm bg-primary/75 hover:bg-primary transition-colors duration-200"
                  style={{ height: `${Math.max((m.amount / max) * 85, m.amount > 0 ? 3 : 1)}%` }}
                  data-testid={`month-bar-${m.month}`}
                />
                <span className="text-[10px] text-muted-foreground">{m.label}</span>
              </div>
            );
          })}
        </div>
        )
      ) : (
        <p className="text-muted-foreground text-sm">Loading…</p>
      )}
      <p className="text-xs text-muted-foreground mt-4">Net revenue over the last 12 months. Hover a bar for the exact amount.</p>
    </CardContent>
  </Card>
);
